import { openModalIframe } from "DMS/Utils/modal";
export default function showVersion() {
    openModalIframe(root + "Information.php", "Informations");
}
//# sourceMappingURL=version.js.map